import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';
import ClientStatusBadges from './ClientStatusBadges';
import ClientAiInsights from './ClientAiInsights';
import ClientContactInfo from './ClientContactInfo';
import ClientActions from './ClientActions';
import { notAvailable } from '../../../utils/formatters';

const ClientCard = ({ client, onChat, onDetails }) => {
  return (
    <Card
      sx={{
        borderRadius: 3,
        borderTop: client.is_currently_assigned_to_me ? '4px solid' : 'none',
        borderTopColor: 'primary.main',
        overflow: 'hidden',
      }}
    >
      <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
        <ClientStatusBadges
          isAssignedToMe={client.is_currently_assigned_to_me}
          hasActiveConversation={!!client.active_lead_uuid}
        />

        <Typography
          variant="h6"
          sx={{
            mb: 1.5,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {client.display_name || notAvailable()}
        </Typography>

        <ClientAiInsights aiInsights={client.ai_insights} />

        <ClientContactInfo
          phone={client.phone_number}
          email={client.email}
          city={client.city}
          state={client.state}
          lastMessageAt={client.last_message_at}
        />

        <ClientActions
          hasActiveConversation={!!client.active_lead_uuid}
          onChat={onChat}
          onDetails={onDetails}
        />
      </CardContent>
    </Card>
  );
};

export default ClientCard;
